import { Controller, Path, useFormContext } from "react-hook-form";

import { Switch } from "src/base-components/Switch";

type NonProdEnvConfig = {
  enableNonProdConfigs: boolean;
};

type Props = {
  dataLoc: string;
  title: string;
  subtitle: string;
};

export const EnableNonProdConfigsField = <T extends NonProdEnvConfig>({
  dataLoc,
  title,
  subtitle,
}: Props): JSX.Element => {
  const { control } = useFormContext<T>();

  return (
    <div className="my-6 flex items-center justify-between">
      <div>
        <h3 className="font-inter-semibold-13px text-gray-800">{title}</h3>
        <span className="font-inter-normal-12px text-gray-500">{subtitle}</span>
      </div>
      <Controller
        control={control}
        name={"enableNonProdConfigs" as Path<T>}
        render={(props) => (
          <Switch
            dataLoc={dataLoc}
            enabled={!!props.field.value}
            onChange={() => {
              props.field.onChange(!props.field.value);
            }}
          />
        )}
      />
    </div>
  );
};
